/**
 * Before Vue boots: copy legacy sessionStorage sub-nav flag into a cookie
 * so the next document request (and client useCookie) can SSR-match collapsed chrome.
 */
export default defineNuxtPlugin({
  name: 'lip-sub-nav-collapsed-init',
  enforce: 'pre',
  order: -4,
  setup() {
    if (!import.meta.client) return

    const key = 'lip-dashboard-sub-nav-collapsed'
    try {
      const match = document.cookie.match(new RegExp(`(?:^|; )${key}=([^;]*)`))
      const cookieVal = match ? decodeURIComponent(match[1]) : ''
      if (cookieVal === '1' || cookieVal === '0') return

      const sessionVal = sessionStorage.getItem(key)
      if (sessionVal !== '1' && sessionVal !== '0') return

      const secure = location.protocol === 'https:' ? '; Secure' : ''
      document.cookie = `${key}=${sessionVal}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`
    } catch {
      /* private mode */
    }
  },
})
